import { Checkbox } from 'antd';

export default function AppCheckbox({ checked, onChange, label }) {
  return (
    <Checkbox checked={checked} onChange={onChange}>
      {label}
    </Checkbox>
  );
}
